{
  "appName": "Pribram App",
  "placeholder": "Phase 0 scaffold — app is running."
}
